import React from 'react'
import { map, find } from 'lodash'

import { Input } from "@driftt/tide-core-legacy"
import { userTitle } from './constants'

import StatusAvatar from 'components/shared/AgentStatusAvatar'

const getUserRole = user => {
  if (user.scopes.includes('calendar_user')) {
    return 'Calendar User'
  }
  if (user.scopes.includes('org_admin')) {
    return 'Admin'
  }
  return 'Chat User'
}

export default ({ users, onUserSelect, selectedMembers }) => (
  map(users, user => (
    {
      data: [
        {
          className: "team-member-table-check-all",
          content: (
            <Input type="checkbox" checked={find(selectedMembers, { id: user.id })} onChange={() => onUserSelect(user)}/>
          )
        },
        {
          content: (
            <div className="team-member-table-user">
              <StatusAvatar user={user} />
              <div className="team-member-table-user-name">
                <p>{userTitle(user)}</p>
                <p>{user.email}</p>
              </div>
            </div>
          )
        },
        {
          className: "team-permissions",
          content: (
            <div>
              <span className="user-scope">{getUserRole(user)}</span>
            </div>
          )
        }
      ]
    }
  ))
)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/team/MemberSelectorTable/RowFormatter.js